import React from 'react';

import { Chip, makeStyles, Tooltip, useMediaQuery, useTheme } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import stringShortener from 'helpers/stringShortener';
import general_messages from 'messages/general_messages';

const useStyles = makeStyles(theme => ({
  chip: {
    '&.Mui-focusVisible, &:focus-visible': {
      outline: `3px solid ${theme.palette.grey[300]}`,
      outlineOffset: 2,
    },
  },
}));

const FilterChip = ({ name, id, deleteFilter, addFilter, isSelected, sectionKey, tooltip }) => {
  const { t } = useTranslation();
  const translatedName = t(name);
  const label = stringShortener(translatedName, 35);
  const actionLabel = isSelected
    ? t(...general_messages.remove_filter, { filter: translatedName })
    : t(...general_messages.add_filter, { filter: translatedName });

  const onClick = () => {
    if (isSelected) deleteFilter({ id, sectionKey });
    else addFilter({ id, name, sectionKey });
  };

  const theme = useTheme();
  const upSm = useMediaQuery(theme.breakpoints.up('sm'));
  const styles = useStyles();

  const chip = (
    <Chip
      aria-label={actionLabel}
      aria-pressed={Boolean(isSelected)}
      className={styles.chip}
      data-testid={`${id}-filter-chip`}
      icon={isSelected ? <CheckIcon /> : undefined}
      label={label}
      onClick={onClick}
      size={upSm ? 'medium' : 'small'}
    />
  );

  if (!tooltip) {
    return chip;
  }

  return (
    <Tooltip arrow title={tooltip}>
      <span>{chip}</span>
    </Tooltip>
  );
};

FilterChip.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  deleteFilter: PropTypes.func.isRequired,
  addFilter: PropTypes.func,
  isSelected: PropTypes.bool,
  sectionKey: PropTypes.string.isRequired,
  tooltip: PropTypes.string,
};

FilterChip.defaultProps = {
  isSelected: false,
  addFilter: () => {},
  tooltip: undefined,
};

export default FilterChip;
